import { useTranslation } from 'react-i18next';
import { CalendarDays, Check, Icon } from '../../../ui/Icon';
import DateRangeCalendar from '../../../ui/DateRangeCalendar';
import type { DatesAnswer } from '../useDatesAnswer';

interface Props {
  dates: DatesAnswer;
  formatRange: (start: string, end: string, nights: number) => string;
}

export default function DatesStep({ dates, formatRange }: Props) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div className="relative">
        <Icon as={CalendarDays} size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
        <input
          autoFocus type="text"
          className="input !h-12 !pl-11 !text-[15px] !rounded-2xl"
          placeholder={t('dashboard.newTripWizard.datesPlaceholder')}
          value={dates.text}
          disabled={dates.loading}
          onChange={e => dates.onTextChange(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); dates.submit(); } }}
        />
      </div>
      {dates.error ? (
        <p className="text-[13px] text-red-500">{dates.error}</p>
      ) : dates.range ? (
        <p className="flex items-center gap-1.5 text-[13px] font-medium text-teal-600 dark:text-teal-400">
          <Icon as={Check} size={14} className="shrink-0" />
          {formatRange(dates.range.startDate, dates.range.endDate, dates.range.nights)}
        </p>
      ) : (
        <p className="text-[13px] text-slate-400 dark:text-slate-500">{t('dashboard.newTripWizard.datesPickHint')}</p>
      )}
      <DateRangeCalendar start={dates.sel.start} end={dates.sel.end} onChange={dates.onCalendarChange} />
    </div>
  );
}
